// extracted by mini-css-extract-plugin
export default {"container":"DeleteButton_container__h23xX","icon":"DeleteButton_icon__8JQS9","edit-block":"DeleteButton_edit-block__hMBHI","edit-button":"DeleteButton_edit-button__JzJ-A"};